<div class="progress-bar">
    <div class="progress-text">Resuming your session...</div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
 